import api from "@/lib/axios";

export const getCategories = async () => {
  const { data } = await api.get("/categories");
  return data.data;
};

export const createCategory = async (payload) => {
  const { data } = await api.post("/categories", payload);
  return data.data;
};

export const updateCategory = async (id, payload) => {
  const { data } = await api.patch(`/categories/${id}`, payload);
  return data.data;
};

export const deleteCategory = async (id) => {
  const { data } = await api.delete(`/categories/${id}`);
  return data.data;
};

export const updateCategoryRank = async (ranks) => {
  const { data } = await api.patch("/categories/rank", { ranks });
  return data.data;
};

export const uploadCategoryImage = async (id, formData) => {
  const { data } = await api.patch(`/categories/${id}/image`, formData);
  return data.data;
};

export const removeCategoryImage = async (id) => {
  const { data } = await api.delete(`/categories/${id}/image`);
  return data.data;
};
